import { render, staticRenderFns } from "./album.vue?vue&type=template&id=5276d78a&scoped=true"
import script from "./album.vue?vue&type=script&lang=js"
export * from "./album.vue?vue&type=script&lang=js"
import style0 from "./album.vue?vue&type=style&index=0&id=5276d78a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5276d78a",
  null
  
)

export default component.exports